import { omit } from 'lodash-es';

export interface PublishData {
  name: string;
  cover: string;
  url: string;
  title: string;
  id: string;
  project_id: number;
  room_type: string;
  generate_record_task_id: string;
}

export interface ProgressItem {
  count?: number; // 进行中数量
  show?: boolean; // 是否显示卡片
  list?: []; // 数据
}

export enum PROGRESS_TYPE {
  PUBLISH = 'publish',
  DOWNLOAD = 'download',
  RENDER = 'rendering',
}

export type ProgressName = 'publish' | 'download' | 'rendering';

type Item = {
  [key in PROGRESS_TYPE]?: ProgressItem;
};

// 用户发布视频信息
export const usePublishInfo = () => {
  return useState<undefined | PublishData>('publishInfo', () => undefined);
};

// 发布进行中显示
export const usePublishProcess = () => {
  return useState<undefined | PublishData>('showPublish', () => undefined);
};

// 显示多个图标及图标对应弹窗
export const useProgress = () => {
  return useState<Item | undefined>('progressList', () => undefined);
};

export const clearProgress = () => {
  const progressList = useProgress();
  progressList.value = undefined;
};

// 设置参数变更
export const setProgress = (key: ProgressName, value: ProgressItem | undefined) => {
  const progressList = useProgress();

  if (!value) {
    // progressList.value = {
    //   ...progressList.value,
    //   [key]: undefined,
    // }
    progressList.value = omit(progressList.value, key);
    // return
  } else {
    if (progressList?.value?.[key]) {
      // progressList.value =
      progressList.value[key] = {
        ...progressList.value[key],
        ...value,
      };
    } else {
      progressList.value = {
        ...progressList.value,
        [key]: value,
      };
    }

    const result: any = Object.keys(progressList.value);
    result.forEach((item: ProgressName) => {
      if (value?.show && item !== key && progressList.value?.[item]) {
        progressList.value[item] = {
          ...progressList.value[item],
          show: false,
        };
      }
    });
  }
};
